module.exports = "/_next/static/images/devOps-2ccb215dea6f3a1335efb7682ba07f05.jpg.webp";